<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="progression-levels" 
    [viewName]="title"
    [record]="progressionLevelRecord"
    [fields]="fields"
    [isNotesPopUp]="true"
    [parentViewName]="parentViewName"
>
</dynamic-view-v2>
